import React from 'react';
import { theme } from 'theme';
import { Card, Grid, styled } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import PersonIcon from '@material-ui/icons/Person';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { SdmTextButton, SdmTypography } from 'components';
import { format } from 'date-fns';
import { slotStatus } from 'utils/constants';

const StyledCard = styled(Card)(({ isSmDown }) => ({
  backgroundColor: theme.colors.primary.white,
  borderLeft: `${isSmDown ? 5 : 10}px solid ${theme.colors.primary.red}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: isSmDown ? 5 : 10,
  marginBottom: 16,
  borderRadius: 0,
  height: 152,
}));

const ActionLink = styled('div')(({ avoidPointer = false }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  cursor: avoidPointer ? 'arrow' : 'pointer',
}));

const Request = ({
  request,
  isSmDown,
  isXsDown,
  i18n,
  context,
  onView,
  onCheckIn,
  onDelete,
}) => {
  const handleView = () => onView?.(request);
  const handleDelete = () => onDelete?.(request);
  const handleCheckIn = () => onCheckIn?.(request);

  return (
    <StyledCard isSmDown={isSmDown}>
      <Grid container alignItems={'center'}>
        <Grid item md={4} sm={6} xs={6}>
          <div
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <SdmTypography
              variant={isXsDown ? 'text' : 'h2Regular'}
              style={{
                width: '100%',
                color: theme.colors.primary.black,
              }}
            >
              {format(new Date(request.start), 'HH:mm')}-
              {format(new Date(request.end), 'HH:mm')}
            </SdmTypography>

            <SdmTypography
              variant={isXsDown ? 'text' : 'h2Regular'}
              style={{
                width: '100%',
                color: theme.colors.primary.black,
              }}
            >
              {request.givenName} {request.familyName}
            </SdmTypography>
          </div>
        </Grid>
        <Grid item md={3} sm={6} xs={6}>
          <div
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              gap: 20,
            }}
          >
            {context === slotStatus.PENDING && (
              <SdmTypography
                variant={isXsDown ? 'text' : 'h2Regular'}
                style={{
                  width: '100%',
                  color: theme.colors.primary.black,
                }}
              >
                {i18n.available} - {request.availableSlots}
              </SdmTypography>
            )}
            {context === slotStatus.CONFIRMED && (
              <>
                {request.referent ? (
                  <ActionLink avoidPointer={true}>
                    <PersonIcon
                      style={{
                        color: 'black',
                        marginRight: 8,
                      }}
                    />
                    <SdmTypography
                      variant={'h4Regular'}
                      margin={0}
                      style={{
                        color: 'black',
                        marginTop: 3,
                      }}
                    >
                      {request.referent.givenName} {request.referent.familyName}
                    </SdmTypography>
                  </ActionLink>
                ) : (
                  <>
                    <ActionLink onClick={() => handleView()}>
                      <PersonAddIcon
                        style={{
                          color: theme.colors.primary.red,
                          marginRight: 8,
                        }}
                      />
                      <SdmTypography
                        variant={'h4Regular'}
                        margin={0}
                        style={{
                          color: theme.colors.primary.red,
                          marginTop: 3,
                        }}
                      >
                        {i18n.buttons.add}
                      </SdmTypography>
                    </ActionLink>
                  </>
                )}
              </>
            )}
            {context === slotStatus.CHECKED && request.referent && (
              <ActionLink avoidPointer={true}>
                <PersonIcon
                  style={{
                    color: 'black',
                    marginRight: 8,
                  }}
                />
                <SdmTypography
                  variant={'h4Regular'}
                  margin={0}
                  style={{
                    color: 'black',
                    marginTop: 3,
                  }}
                >
                  {request.referent.givenName} {request.referent.familyName}
                </SdmTypography>
              </ActionLink>
            )}
          </div>
        </Grid>
        <Grid item md={5} sm={12} xs={12}>
          <div
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              justifyContent: isSmDown ? 'center' : 'flex-end',
              flexWrap: 'wrap',
              marginTop: isXsDown ? 20 : 0,
            }}
          >
            {context === slotStatus.PENDING && (
              <SdmTextButton
                textVariant={isSmDown ? 'h4Regular' : 'h2Regular'}
                text={i18n.buttons.view}
                variant="redFill"
                onClick={() => handleView()}
                style={{
                  minWidth: isXsDown ? 30 : 148,
                  height: isXsDown ? 36 : 46,
                  marginLeft: isSmDown ? 0 : 'auto',
                }}
              />
            )}
            {context === slotStatus.CONFIRMED && (
              <>
                <ActionLink onClick={() => handleView()}>
                  <VisibilityIcon
                    style={{
                      color: theme.colors.primary.red,
                      marginRight: 8,
                    }}
                  />
                  <SdmTypography
                    variant={'h4Regular'}
                    margin={0}
                    style={{
                      color: theme.colors.primary.red,
                      marginTop: 3,
                    }}
                  >
                    {i18n.buttons.view}
                  </SdmTypography>
                </ActionLink>
                <ActionLink onClick={() => handleDelete()}>
                  <DeleteIcon
                    style={{
                      color: theme.colors.primary.red,
                      marginRight: 8,
                    }}
                  />
                  <SdmTypography
                    variant={'h4Regular'}
                    margin={0}
                    style={{
                      color: theme.colors.primary.red,
                      marginTop: 3,
                    }}
                  >
                    {i18n.buttons.delete}
                  </SdmTypography>
                </ActionLink>
                <SdmTextButton
                  textVariant={isSmDown ? 'h4Regular' : 'h2Regular'}
                  text={i18n.buttons.check}
                  variant="redFill"
                  onClick={() => handleCheckIn()}
                  style={{
                    minWidth: isXsDown ? 30 : 148,
                    height: isXsDown ? 36 : 46,
                    // marginLeft: isSmDown ? 0 : 'auto',
                  }}
                />
              </>
            )}
            {context === slotStatus.CHECKED && (
              <ActionLink onClick={() => handleView()}>
                <VisibilityIcon
                  style={{
                    color: theme.colors.primary.red,
                    marginRight: 8,
                  }}
                />
                <SdmTypography
                  variant={'h4Regular'}
                  margin={0}
                  style={{
                    color: theme.colors.primary.red,
                    marginTop: 3,
                  }}
                >
                  {i18n.buttons.view}
                </SdmTypography>
              </ActionLink>
            )}
          </div>
        </Grid>
      </Grid>
    </StyledCard>
  );
};
export default Request;
